<template>
  <WebChapterTemplate
    page-title="附录"
    section-label="研究生教育"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <div class="appendix-page">
      <section class="appendix-section">
        <div class="appendix-section__header">
          <p class="appendix-section__kicker">附录</p>
          <h2 class="appendix-section__title">新闻学与传播学系历任系领导名单</h2>
        </div>

        <div class="appendix-table-wrap">
          <table class="appendix-table">
            <thead>
              <tr>
                <th>任期</th>
                <th>时间</th>
                <th>主任</th>
                <th>副主任</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in leaders" :key="row.term">
                <td>{{ row.term }}</td>
                <td>{{ row.period }}</td>
                <td>{{ row.director }}</td>
                <td>{{ row.deputy }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="appendix-section">
        <div class="appendix-section__header">
          <p class="appendix-section__kicker">导师名录</p>
          <h2 class="appendix-section__title">中国社会科学院研究生院新闻学与传播学系历任导师名录（按姓名音序排列）</h2>
        </div>

        <div class="appendix-card">
          <h3 class="appendix-card__title">现任导师</h3>
          <div class="appendix-card__group">
            <h4>博士生导师</h4>
            <p>{{ currentDoctoral }}</p>
          </div>
          <div class="appendix-card__group">
            <h4>硕士生导师</h4>
            <p>{{ currentMasters }}</p>
          </div>
        </div>

        <div class="appendix-card">
          <h3 class="appendix-card__title">曾任导师</h3>
          <div class="appendix-card__group">
            <h4>博士生导师</h4>
            <p>{{ formerDoctoral }}</p>
          </div>
          <div class="appendix-card__group">
            <h4>硕士生导师</h4>
            <p v-for="line in formerMastersLines" :key="line">{{ line }}</p>
          </div>
          <p class="appendix-note">说明：本名录由新闻学与传播学系根据研究生院教务处提供的《导师信息表》和《新闻系论文题录库》导师名单确定。</p>
        </div>
      </section>
    </div>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'LanhuFulu',
  components: {
    WebChapterTemplate
  },
  data() {
    return {
      sectionRoute: '/lanhu_jiaoyuyurencai',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      leaders: [
        { term: '第一任', period: '1978—1982', director: '谭 立', deputy: '裴 达、红 谦' },
        { term: '第二任', period: '1982—1987', director: '裴 达', deputy: '红 谦' },
        { term: '第三任', period: '1987—1992', director: '邱光欣', deputy: '红 谦、刘忠熙' },
        { term: '第四任', period: '1992—1993', director: '', deputy: '刘忠熙（主持工作）' },
        { term: '第五任', period: '1993—1997', director: '孙富忱', deputy: '王武录、王永安' },
        { term: '第六任', period: '1997—2001', director: '王永安', deputy: '沈兴耕' },
        { term: '第七任', period: '2001—2003', director: '尹韵公', deputy: '' },
        { term: '第八任', period: '2003—2006', director: '张西明', deputy: '' },
        { term: '第九任', period: '2006 至今', director: '唐绪军', deputy: '宋小卫' }
      ],
      currentDoctoral: '卜 卫、黄楚新、季为民、姜 飞、宋小卫、唐绪军、殷 乐',
      currentMasters: '冷 凇、刘瑞生、刘晓红、刘志明、孟 威、钱莲生、时统宇、孙五三、王凤翔、王怡红、向 芬、杨斌艳、杨瑞明、张 丹、张 放、张建珍、张满丽、朱鸿军',
      formerDoctoral: '陈力丹、范敬宜、李仁臣、邵华泽、谢宏、尹韵公、于 宁、张西明、周瑞金',
      formerMastersLines: [
        '艾 丰、安 岗、安子贞、班明丽、保育钧、毕全忠、曹孔瑞、曹宪文、陈柏生、陈崇山、陈封雄、陈耕涛、陈 辉、陈 砾、陈 龙、陈 清、陈泉碧、',
        '陈瑞宁、陈声涛、陈谈强、陈特安、陈瑶华、陈勇进、陈有为、陈祖声、成 一、丛林中、崔 奇、崔筱桐、戴 邦、丹 林、丁济沧、丁仰言、丁仰炎、',
        '丁振海、董乐山、杜运燮、段存章、段心强、樊明经、范乐善、范荣康、范颂九、方 成、方辉盛、方 蒙、冯锡良、傅 真、高 集、顾 雷、关在汉、',
        '官建文、果永毅、何炳然、何崇元、何光先、何庭庆、红 谦、洪和临、胡根康、胡绩伟、胡思升、黄彩忠、黄 钢、黄际昌、黄力仑、黄美来、黄 晴、',
        '黄 庆、黄岳军、黄祖民、计泓庚、纪希晨、季 音、江绍高、江 夏、姜德明、蒋亚平、蒋荫安、蒋元椿、蒋元明、金 凤、金铿然、金绍卿、柯月霖、',
        '李成华、李德民、李定中、李 峰、李梦莲、李耐因、李 普、李 启、李斯颐、李 文、李希凡、李新彦、李延宁、李 洋、李云飞、李长久、李志高、',
        '李竹润、梁丽娟、廖胡今、林 枫、林 钢、林 洪、林 里、林 晰、凌建华、刘宾雁、刘炳文、刘大保、刘砥中、刘工践、刘家杰、刘晶雯、刘其中、',
        '刘时平、刘晓洲、刘学渊、刘允洲、鲁 牧、陆亨俊、陆宏德、陆振华、罗尔庄、罗荣兴、吕建中、马 光、马鹤青、马世琨、孟晓云、闵大洪、明安香、',
        '缪宝根、缪海棱、缪俊杰、穆 青、穆 扬、裴 达、彭 迪、皮树义、钱 行、钱 江、钱湜春、钱湜辛、钱文荣、钱辛波、任毓俊、芮宛如、商 恺、',
        '申德贻、沈如钢、沈兴耕、施大鹏、施松卿、石西民、石西明、石 英、宋世琦、孙富忱、孙剑霞、孙 乃、孙旭培、孙雪天、谭 立、谭文瑞、唐闻生、',
        '陶 涵、田 流、田钟洛、王必胜、王崇杰、王 飞、王惠平、王金和、王 敬、王礼明、王平兴、王 纬、王闻翔、王武录、王艺舟、王英秀、王永安、',
        '王咏赋、王 禺、王泽民、王 政、温济泽、吴德烈、吴恒权、吴继淦、吴 晋、吴景枢、吴其慧、吴学林、吴元富、吴月辉、武春河、席林生、谢冰岩、',
        '谢国明、邢象超、熊 复、熊 蕾、熊铮彦、徐成时、徐 放、徐 林、徐 麟、徐 熊、徐学江、徐耀魁、严泉兴、杨国钧、杨 木、杨润时、姚力文、',
        '姚 云、叶 周、伊心恬、尹品端、应 谦、于恩光、于 明、于明波、于 友、余焕春、余振鹏、俞成秀、虞家复、郁隽民、喻权域、袁 疆、袁志发、',
        '翟向东、翟象乾、张宝林、张璧华、张慈赟、张虎生、张惠民、张敬先、张 黎、张 力、张连德、张 亮、张 沛、张启昕、张千祥、张研农、张振亚、',
        '章南舍、章挺权、赵一鹤、赵仲华、郑德芳、郑荣来、钟立群、周立方、周 庆、周世禄、周修强、周则鑫、朱敏信、朱荣根、朱世达、朱英璜、朱元胜'
      ]
    };
  }
};
</script>

<style scoped>
.appendix-page {
  display: grid;
  gap: 28px;
}

.appendix-section {
  padding: 26px;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background:
    linear-gradient(140deg, rgba(248, 242, 233, 0.84), rgba(255, 255, 255, 0) 42%),
    linear-gradient(180deg, #fff, rgba(253, 250, 246, 0.96));
  box-shadow: 0 14px 30px rgba(59, 41, 17, 0.05);
}

.appendix-section__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 20px;
  margin-bottom: 22px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(179, 145, 101, 0.16);
}

.appendix-section__kicker {
  margin: 0;
  color: #b28a56;
  font-size: 12px;
  line-height: 1.4;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.appendix-section__title {
  margin: 0;
  color: #f25c19;
  font-size: 26px;
  line-height: 1.4;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
  font-weight: 700;
}

.appendix-table-wrap {
  overflow-x: auto;
}

.appendix-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
  color: #2f2a25;
}

.appendix-table th,
.appendix-table td {
  padding: 12px 14px;
  border: 1px solid rgba(179, 145, 101, 0.22);
  text-align: left;
  vertical-align: top;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.appendix-table th {
  background: rgba(243, 236, 224, 0.65);
  font-weight: 700;
}

.appendix-card {
  padding: 22px;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.16);
  background: #fff;
  box-shadow: 0 10px 24px rgba(45, 33, 16, 0.05);
}

.appendix-card + .appendix-card {
  margin-top: 20px;
}

.appendix-card__title {
  margin: 0 0 16px;
  color: #231f20;
  font-size: 22px;
  line-height: 1.5;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
}

.appendix-card__group + .appendix-card__group {
  margin-top: 18px;
}

.appendix-card__group h4 {
  margin: 0 0 10px;
  color: #b28a56;
  font-size: 16px;
  line-height: 1.6;
}

.appendix-card__group p,
.appendix-note {
  margin: 0 0 10px;
  color: #4e463d;
  font-size: 15px;
  line-height: 2;
  text-align: justify;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.appendix-note {
  margin-top: 16px;
  font-size: 14px;
}

@media (max-width: 768px) {
  .appendix-section {
    padding: 20px;
  }

  .appendix-section__title {
    font-size: 22px;
  }

  .appendix-table {
    font-size: 14px;
  }
}
</style>
